import { Component, Inject } from '@angular/core';
import { UntypedFormGroup, FormBuilder, FormControl, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '@src/app/shared/services/api.service';
import moment from 'moment';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-delete-price-tier-modal',
    templateUrl: './delete-price-tier-modal.component.html',
})
export class DeletePriceTierModalComponent {
    public priceTierForm: UntypedFormGroup;
    public currentDate: Date = new Date();

    constructor(
        private apiService: ApiService,
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<DeletePriceTierModalComponent>,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: { priceTier: any, type: string, effectiveFrom?: Date }
    ) {

    }

    ngOnInit(): void {
        if (this.data?.effectiveFrom) {
            this.currentDate = this.data.effectiveFrom;
        }
        this.initForm();
    }

    private initForm(): void {
        this.priceTierForm = new UntypedFormGroup({
            id: new UntypedFormControl(
                this.data?.priceTier ? this.data?.priceTier?.id : ''
            ),
            effective_to: new FormControl<Date>(null, Validators.required),
            tier: new UntypedFormControl(
                { value: this.data?.priceTier?.tier ?? 0, disabled: true }
            )
        });
    }

    public removeTier(): Promise<void> {
        if (this.priceTierForm.valid) {
            return Swal.fire({
                title: `Are you sure want to delete this price tier?`,
                icon: 'warning',
                iconColor: '#ff9030',
                background: '#424242',
                customClass: {
                    title: 'sweetAlertTitle'
                },
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(async (result) => {
                if (result.value) {
                    this.priceTierForm.patchValue({
                        effective_to: moment(this.priceTierForm.get('effective_to')?.value).format('YYYY-MM-DD HH:mm:ss'),
                    });

                    this.apiService.post(`products/prices/${this.data?.priceTier?.id}/delete`, this.priceTierForm.getRawValue()).subscribe(
                        response => {
                            this.snackBar.open('Price tier deleted successfully', 'Close', {
                                duration: 3000,
                                panelClass: ['success-snackbar']
                            });
                            this.dialogRef.close(true);
                        },
                        error => {
                            this.apiService.handleError(error);
                            this.snackBar.open('Failed to delete price tier', 'Close', {
                                duration: 3000,
                                panelClass: ['error-snackbar']
                            });
                        }
                    );
                }
            });
        } else {
            this.snackBar.open('Please enter an Effective To date', 'Close', {
                duration: 3000,
                panelClass: ['error-snackbar']
            });
        }
        return Promise.resolve();
    }

}
